import { createFileRoute } from "@tanstack/react-router";
import { DeFiPage } from "../../features/defi/pages/defi-page";
import { prefetchSdkTokens } from "../../shared/utils/tokens-data.ts";

export const Route = createFileRoute("/_layout/defi")({
  loader: () => {
    // Fire and forget with error handling
    prefetchSdkTokens({ tagLimit: ["stablecoin"] }).catch(console.warn);
    return null; // resolves immediately; route can render
  },
  component: DeFiPage,
});
